import React, { useState } from "react";
import styles from "./FeedList.module.css";
import PropTypes from "prop-types";
import FeedListItem from "../FeedListItem";

/**
 * List of scrollable feed items.
 */

export function FeedList({ feedItems, onClone, onCloneAU, onEdit, onSync }) {
  return (
    <div className={styles.list}>
      {feedItems.map((item, index) => (
        <FeedListItem
          key={item.id || index} // Use a unique id if available, fallback to index
          feedItem={item}
          onClone={onClone}
          onCloneAU={onCloneAU}
          onEdit={onEdit}
          onSync={onSync}
        />
      ))}
    </div>
  );
}

FeedList.propTypes = {
  // Array of feed items.
  // Update to expect an array (for the raw data from the API), add onClone and onEdit
  feedItems: PropTypes.array.isRequired,
  onClone: PropTypes.func.isRequired,
  onCloneAu: PropTypes.func,
  onEdit: PropTypes.func.isRequired,
  onSync: PropTypes.func.isRequired
};
